<template>
  <v-select
    v-model="internalValue"
    :items="publicStrategy"
    :multiple="multiple"
    :clearable="clearable"
    :label="label"
    :loading="loading"
    :disabled="disabled"
    flat
    box
    success
    class="text-details-none"
    item-text="name"
    item-value="value"
  >
    <template v-slot:selection="{ item, index }">
      <span v-if="index === 0" class="mr-1">
        {{ item.name }}
      </span>
      <span v-if="index === 1" class="grey--text caption">
        (+{{ internalValue.length - 1 }}
        {{ internalValue.length === 2 ? "outro" : "outros" }})
      </span>
    </template>
  </v-select>
</template>

<script>
import strategyPublic from "@/utils/strategy-public";

export default {
  name: "SelectStrategicPublic",
  props: {
    value: {
      type: [Array, String, Number],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: "Público",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      publicStrategy: [],
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  created() {
    this.setStrategyPublic();
  },
  methods: {
    setStrategyPublic() {
      if (strategyPublic && strategyPublic.strategyPublic) {
        this.publicStrategy = strategyPublic.strategyPublic;
      }
    },
  },
};
</script>
